import { StaticImage } from "gatsby-plugin-image"
import { useCallback } from "react"

import SignupContainer from "./signup-container"
import SignupTop from "./signup-top"

const SignupV1 = () => {
  const image = useCallback(
    ({ alt, className }) => (
      <StaticImage
        src="./images/signup-v1.webp"
        alt={alt}
        className={className}
      />
    ),
    []
  )

  return (
    <SignupContainer buttonLabel="Behandlungsplan sehen">
      <SignupTop
        heading={
          <>
            Geschafft – sieh Dir <br /> jetzt Deinen Behandlungsplan an!
          </>
        }
        subline="Gib Deine E-Mail ein und erhalte Deine persönliche Skincare-Empfehlung."
        image={image}
      />
    </SignupContainer>
  )
}

export default SignupV1
